import * as t from './actionTypes';

export function updateToggleAllEntities(checked /*: boolean */, ids /* ?: any[] */) {
  return {
    type: checked ? t.SELECT_ALL_ENTITIES : t.DESELECT_ALL_ENTITIES,
    ids,
  };
}

export function removeEntity(pill) {
  const id = pill.value;
  return {
    type: t.REMOVE_ENTITY,
    id,
  };
}
